import { h, ref } from 'vue';
import { inputField, dropdownField } from '@/ui/components/form';
import { ScaleType, TimeWindow } from '@/entities/auth/reminderConfiguration';
import { SelectOptions } from '@/ui/types';

export function useTimeWindowBox(timeSetting: TimeWindow) {
  const record = ref<TimeWindow>(timeSetting);

  const formFields = (
    scaleOptions: SelectOptions<string>,
  ) => {
    return [
      h('div',
        { class: 'reminder-configurations__table-column' },
        [
          inputField({
            name: 'value',
            type: 'number',
            label: '',
            classes: 'reminder-configurations__input',
            value: record.value.data.value,
            placeholder: '',
            required: false,
            errors: [],
            disabled: false,
          }, v => {
            record.value.data.value = v || v === '0' ? Number(v) : null;
          }),

          dropdownField({
            name: 'scale',
            label: '',
            value: record.value.data.scale,
            placeholder: '',
            required: false,
            options: scaleOptions,
            errors: [],
            disabled: false,
          }, value => {
            record.value.data.scale = value as ScaleType;
          }),
        ]),
    ];
  };

  return {
    formFields,
  };
}
